exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-7214470a]{transition:all .2s ease}.card[data-v-7214470a]:hover{transform:translateY(-2px);box-shadow:0 4px 8px rgba(0,0,0,.1)}", ""]);

// exports
